import { supabase } from "./supabase";
import { createInvoiceOnly } from "./pelecardInvoiceOnly";

const PELECARD_BASE = {
  production: "https://gateway20.pelecard.biz/services",
  sandbox: "https://gateway21.pelecard.biz/services/DebitRegularType",
};

// שמירת תוצאת עסקה ל-DB
export async function saveTransactionResult(params: {
  businessId: string;
  customerId: string;
  appointmentId?: string;
  pelecardTransactionId?: string;
  approvalCode?: string;
  amount: number;
  currency: number;
  invoiceLink?: string;
  status: "success" | "error";
  errorMessage?: string;
}) {
  await supabase.from("payment_transactions").insert([
    {
      business_id: params.businessId,
      customer_id: params.customerId,
      appointment_id: params.appointmentId || null,
      pelecard_transaction_id: params.pelecardTransactionId,
      approval_code: params.approvalCode,
      amount: params.amount,
      currency: params.currency,
      payment_method: "credit_card",
      invoice_link: params.invoiceLink,
      status: params.status,
      error_message: params.errorMessage,
    },
  ]);
}

/**
 * חיוב לקוח בענן פלכארד (כולל הפקת חשבונית)
 */
export async function chargeCustomerWithCloudTerminal(params: {
  terminalNumber?: string;
  user?: string;
  password?: string;
  shopNumber?: string;

  amount: number;
  currency?: number;
  payments?: number;
  reference: string;

  businessId: string;
  customerId: string;
  appointmentId?: string;
  terminalId?: string; // ✅ מזהה המסוף הספציפי

  payperParams?: {
    typeDocument: string;
    DataPayper: any;
  };

  sandbox?: boolean;

  /**
   * ✅ חשוב: מגיע מהעסק (פטור/מורשה)
   */
  includeVat: boolean;

  /**
   * אופציונלי (אם כבר יש לך)
   */
  accessToken?: string;
}) {
  const {
    amount,
    currency = 1,
    payments = 1,
    reference,
    businessId,
    customerId,
    appointmentId,
    terminalId,
    payperParams,
    sandbox = true,
    includeVat,
    accessToken,
  } = params;

  try {
    console.log("🔍 pelecardCloud - terminalId מתקבל:", terminalId);

    const requestBody = {
      businessId,
      customerId,
      appointmentId,
      terminalId, // ✅ שליחת מזהה המסוף
      amount,
      tipAmount: 0,
      paymentMethod: "credit_card",
      payments,
      reference,
      serviceDescription: payperParams?.DataPayper?.invoice_lines?.[0]?.description || "חיוב באשראי",
      customerName: payperParams?.DataPayper?.customer_name || "",
     
      customerPhone: payperParams?.DataPayper?.customer_phone || "",
      
    };

    console.log("📤 שולח ל-edge function:", { terminalId: requestBody.terminalId });

    const session = await supabase.auth.getSession();
    const bearer = session.data.session?.access_token || "";

    const response = await fetch(
      "https://nkuqcyelxgyihrxyvitb.functions.supabase.co/charge-terminal",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearer}`,
        },
        body: JSON.stringify(requestBody),
      }
    );

    const responseText = await response.text();
    let responseData: any;
    try {
      responseData = JSON.parse(responseText);
    } catch {
      responseData = { error: responseText };
    }

    if (!responseData?.success) {
      return {
        success: false,
        error: responseData?.error || "העסקה נכשלה. נסה שוב.",
        raw: responseData,
      };
    }

    // הצליח חיוב אשראי -> מפיקים חשבונית לפי includeVat של העסק
    try {
      const token =
        accessToken ||
        (await supabase.auth.getSession()).data.session?.access_token ||
        "";

      const invoiceResult = await createInvoiceOnly(
        {
          businessId,
          customerId,
          appointmentId,
          terminalId,
          amount,
          tipAmount: 0,
          serviceDescription:
            payperParams?.DataPayper?.invoice_lines?.[0]?.description || "חיוב באשראי",
          customerName: payperParams?.DataPayper?.customer_name || "",
          
          customerPhone: payperParams?.DataPayper?.customer_phone || "",
          customerAddress: payperParams?.DataPayper?.customer_address || "לא צויין",
          paymentType: "credit_card",
          includeVat,
          documentRemarks: "תודה שבחרת בנו",
          Uid: responseData.raw?.ResultData?.Uid,
        },
        token,
        { debug: false }
      );

      const invoiceLink =
        invoiceResult?.invoiceLink ||
        invoiceResult?.raw?.PayperData?.InvoiceLink ||
        null;

      const invoiceNumber =
        invoiceResult?.invoiceNumber ||
        invoiceResult?.raw?.PayperData?.InvoiceNumber ||
        null;

      // שמירה ל-DB
      await supabase.from("payment_transactions").insert([
        {
          business_id: businessId,
          customer_id: customerId,
          appointment_id: appointmentId || null,
          amount,
          currency: 1,
          payment_method: "credit_card",
          status: "success",
          invoice_link: invoiceLink,
          created_at: new Date().toISOString(),
        },
      ]);

      return {
        success: true,
        approvalCode: responseData.approvalCode,
        invoiceLink,
        invoiceNumber,
        message: responseData.message,
        raw: responseData.raw,
      };
    } catch (err: any) {
      return {
        success: true,
        approvalCode: responseData.approvalCode,
        invoiceLink: null,
        invoiceNumber: null,
        message: responseData.message,
        raw: responseData.raw,
        invoiceError: err?.message || String(err),
      };
    }
  } catch (error: any) {
    return {
      success: false,
      error: error?.message || "אירעה שגיאה לא צפויה בביצוע החיוב",
    };
  }
}
